export default __webpack_public_path__ + "static/media/stripe.3bf66704.png";